import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
    Toolbar, Tooltip, Typography, Button, withStyles,
} from '@material-ui/core';
import translationPropType from '../../../proptypes/translationPropType';

const styles = theme => ({
    root: {
        paddingRight: theme.spacing(1),
        paddingLeft: 0,
    },
    highlighted: {
        background: theme.palette.primary.light,
        paddingLeft: theme.spacing(2),
    },
    spacer: {
        flex: '1 1 100%',
    },
    titleSelected: {
        color: theme.palette.common.white,
    },
    title: {
        flex: '0 0 auto',
        display: 'flex',
        marginRight: theme.spacing(1),
    },
});

const EnhancedTableToolbar = (props) => {
    const {
        classes,
        title,
        numSelected,
        actionText,
        actionTooltip,
        handleAction,
        translation,
        collapsible,
        collapsed,
        collapseText,
        handleCollapse,
    } = props;

    return (
        <Toolbar
            className={classNames(
                classes.root,
                {
                    [classes.highlighted]: numSelected > 0,
                },
            )}
        >
            <div className={classes.title}>
                {numSelected > 0 ? (
                    <Typography className={classes.titleSelected} variant="subtitle1">
                        {`${numSelected} ${translation.SELECTED}`}
                    </Typography>
                ) : (
                    <>
                        {title && (
                            <Typography className={classes.title} variant="h6" display="inline">
                                {title}
                            </Typography>
                        )}
                        {collapsible && (
                            <Button
                                variant="contained"
                                color={collapsed ? 'primary' : 'secondary'}
                                size="small"
                                onClick={handleCollapse}
                            >
                                {collapsed ? collapseText : translation.CANCEL}
                            </Button>
                        )}
                    </>
                )}
            </div>
            <div className={classes.spacer} />
            <div className={classes.actions}>
                {numSelected > 0 && (
                    <Tooltip title={actionTooltip}>
                        <Button
                            variant="contained"
                            color="default"
                            onClick={handleAction}
                        >
                            {actionText}
                        </Button>
                    </Tooltip>
                )}
            </div>
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
    title: PropTypes.string,
    numSelected: PropTypes.number,
    actionText: PropTypes.string,
    actionTooltip: PropTypes.string,
    handleAction: PropTypes.func,
    translation: translationPropType.isRequired,
    collapsible: PropTypes.bool,
    collapsed: PropTypes.bool,
    collapseText: PropTypes.string,
    handleCollapse: PropTypes.func,
};

EnhancedTableToolbar.defaultProps = {
    numSelected: 0,
    handleAction: null,
    title: null,
    actionText: null,
    actionTooltip: null,
    collapsible: false,
    collapsed: false,
    collapseText: null,
    handleCollapse: null,
};

export default withStyles(styles)(EnhancedTableToolbar);
